module.exports = __webpack_public_path__ + "05_glasses_black.f4dcab18.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer4/05_glasses_black.png
// module id = nv+1
// module chunks = 0